// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1_g4i","cls2":"UserTooltip-cls2_Xwy UserTooltip-cls1_g4i"};